<template>
  <v-container>
    <h1 class="text-center grey--text text--darken-2 mt-4 mb-5">
      FAQS
    </h1>
    <v-row align="center" justify="center">
      <v-col class="mb-5" cols="12" sm="10">
        <v-expansion-panels :accordion="accordion" :focusable="focusable">
          <v-expansion-panel v-for="(faq, i) in faqs" :key="i">
            <v-expansion-panel-header class="font-weight-black">{{
              faq.question
            }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              {{ faq.answer }}
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <div class="my-5 text-center">
      <v-btn
        large
        color="primary"
        @click="$vuetify.goTo('form', { offset: 120 })"
        >Sign up</v-btn
      >
    </div>
  </v-container>
</template>

<script>
export default {
  name: "Landing7Faqs",

  data: () => ({
    accordion: true,
    focusable: true,
    faqs: [
      {
        question: "What is Kahon.ph?",
        answer:
          "Kahon.ph is the only serviced storage company in the Philippines. Unlike traditional self-storage companies, we’ve integrated handling and logistics so that you have the most pleasant storage experience possible. This means that you never go to the storage facility -- you simply manage your items through our website and decide what you want to store and what you want returned.",
      },
      {
        question: "How do I store with Kahon.ph?",
        answer:
          "Storing is easy. You first create an account at https://kahon.ph. After creating an account, you choose which storage solution best fits your needs best. Our storage options can be classified into two more general types -- KAHON (by-the-box) for smaller items, and KWARTO (by-the-square-meter) for larger items that won’t fit in our boxes.",
      },
      {
        question: "Which area does Kahon.ph serve?",
        answer:
          "We currently service the Greater Manila Area, with plans of expanding. Do let us know if you want Kahon.ph to serve your area. The more of you there are in a general area the quicker we can help!",
      },
      {
        question: "What is your minimum storage period?",
        answer:
          "Minimum storage period for Kahon is 3 months, while for Kwarto is 1 month. If you wish to store for a shorter time, please do let us know and we’ll try our best to accommodate your requirement.",
      },
    ],
  }),
};
</script>

<style scoped>
.card-outter {
  position: relative;
  padding-bottom: 50px;
}
.card-actions {
  position: absolute;
  bottom: 0;
}
</style>
